import BaseModel from '../BaseModel';

export default class VacancyFaq extends BaseModel {
  static entity = 'vacancyFaq';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      vacancyId: this.attr(null),
      question: this.string(null).nullable(),
      answer: this.string(null).nullable(),
    };
  }

  static apiConfig = {
    actions: {
      async store(vacancyId, payload) {
        const result = await this.post(`vacancies/${vacancyId}/faq`, payload, { save: false });
        result.response.data.data.vacancyId = vacancyId;
        result.save();
        return result;
      },
      update(id, payload) {
        return this.put(`vacancies/faq/${id}`, payload);
      },
      destroy(id) {
        return this.delete(`vacancies/faq/${id}`, { delete: id });
      },
    },
  }
}
